define.alias("shared/components/shared/post/secondary/hashtag-suggestions/wrapper", "calendar/components/shared/post/secondary/hashtag-suggestions/wrapper");